import type { ReactNode } from "react";
import { StarterPrompts } from "./StarterPrompts";

interface WelcomeScreenProps {
  starters: string[];
  onPick: (text: string) => void;
  composerSlot?: ReactNode;
}

// "Editorial authority with precision": Merriweather headline carries the
// brand voice; Inter body explains the assistant in plain language. No emoji,
// per the NDC design system rules.
//
// Layout follows the familiar assistant pattern (ChatGPT / Copilot / Claude):
// greeting on top, the message input as the focal point directly beneath it,
// then suggested questions below. After the first message the input docks to
// the bottom (handled in App).
export function WelcomeScreen({ starters, onPick, composerSlot }: WelcomeScreenProps) {
  return (
    <section
      className="grid min-h-[calc(100vh-200px)] place-content-center justify-items-center text-center"
      aria-labelledby="welcome-heading"
    >
      <div className="w-full max-w-[760px]">
        {/* Visual anchor — NDC logo mark, theme-aware */}
        <div className="mb-6 flex justify-center">
          <img
            src="/ndc-logo.svg"
            alt=""
            aria-hidden
            className="h-10 w-auto select-none opacity-80 dark:hidden"
            draggable={false}
          />
          <img
            src="/ndc-logo-white.svg"
            alt=""
            aria-hidden
            className="hidden h-10 w-auto select-none opacity-80 dark:block"
            draggable={false}
          />
        </div>
        <h1
          id="welcome-heading"
          className="m-0 mb-3 font-serif font-semibold tracking-[-0.02em] text-text"
          style={{
            fontSize: "clamp(32px, 4.6vw, 46px)",
            lineHeight: 1.14,
          }}
        >
          How can I help?
        </h1>
        <p className="m-0 mb-6 text-[15px] leading-relaxed text-text-muted">
          Ask anything about NDC's systems and software — I'll look it up from the real source.
        </p>

        {composerSlot}

        <StarterPrompts starters={starters} onPick={onPick} />
      </div>
    </section>
  );
}
